import React from 'react';
const Legal = () => {
    return (
        <div>
            <h1 className='h1-legal'>Mentions légales</h1>
            <div className='bloc-legal'>
                <h2 className='h2-legal'> Identité de l'Entreprise</h2>
                Raison sociale : Ouest Camions<br />
                Directeur de la publication : Pascal Alouest

                <h2 className='h2-legal'> Hébergeur du Site</h2>
                <p>OVH</p>
                <p>140 quai du Sartel</p>
                <p>59100 Roubaix</p>
                <p>France</p>

                <h2 className='h2-legal'> Nature des données collectées</h2>
                Dans le cadre de la création de compte, de la gestion des réservations et du traitement des commandes, les données suivantes peuvent être collectées :<br />
                Raison sociale, numéro SIRET, adresse professionnelle<br />
                Nom, prénom, fonction, téléphone professionnel, adresse e-mail<br />
                Historique de réservation, facturation, préférences commerciales<br />
                Données de connexion (logs, adresse IP)<br />
                Informations de paiement (via des prestataires tiers sécurisés)<br />

                <h2 className='h2-legal'> Finalités du traitement</h2>
                Les traitements de données ont pour finalités :<br />
                La gestion des comptes clients professionnels<br />
                La prise en charge des commandes et réservations de véhicules<br />
                L’établissement des devis, contrats et factures<br />
                Le suivi commercial, relation client et assistance<br />
                La prévention de la fraude<br />
                Le respect des obligations légales, comptables et fiscales<br />

                <h2 className='h2-legal'> Base légale du traitement</h2>
                Les traitements sont effectués sur les fondements suivants :<br />
                L'exécution d’un contrat ou de mesures précontractuelles<br />
                Le respect d’une obligation légale<br />
                L’intérêt légitime du responsable de traitement à assurer la gestion commerciale de son activité<br />

                <h2 className='h2-legal'> Durée de conservation</h2>
                Les données sont conservées :<br />
                Pendant la durée de la relation contractuelle, augmentée de 3 ans à des fins de prospection<br />
                Pendant 10 ans pour les documents comptables (factures, contrats, etc.)<br />
                Pendant 12 mois pour les données de connexion à compter de leur collecte<br />


                <h2 className='h2-legal'> Destinataires des données</h2>
                Les données sont destinées exclusivement à [Nom de votre société] et à ses prestataires agissant en qualité de sous-traitants, notamment :<br />
                Hébergeur du site<br />
                Fournisseur de solution de paiement (ex. PayPal)<br />
                Prestataire de maintenance ou support technique<br />
                Aucun transfert de données hors Union européenne n’est effectué sans garanties adéquates.<br />

                <h2 className='h2-legal'> Droits des personnes concernées</h2>
                Conformément aux articles 15 à 22 du RGPD, toute personne concernée dispose :<br />
                D’un droit d’accès, de rectification, d’effacement<br />
                D’un droit de limitation et d’opposition pour motifs légitimes<br />
                D’un droit à la portabilité de ses données<br />
                Du droit de définir le sort de ses données post-mortem<br />
                Les demandes peuvent être adressées à :<br />
                [reclamation@ouestcamions@fr]<br />
                accompagnées d’un justificatif d’identité le cas échéant.<br />
                En cas de difficulté non résolue, vous pouvez saisir la CNIL (www.cnil.fr).<br />

                <h2 className='h2-legal'> Cookies et traceurs</h2>
                Le site utilise des cookies strictement nécessaires à son fonctionnement ainsi que, sous réserve de votre consentement, des cookies de mesure d’audience ou de services tiers (ex. YouTube, Google Analytics).:<br />
                Un bandeau d'information et un module de gestion des cookies (conforme au RGPD) vous permettent de paramétrer vos préférences à tout moment.:<br />

                <h2 className='h2-legal'> Propriété Intellectuelle</h2>
                Le contenu de ce site est protégé par des droits d'auteur. Toute reproduction est interdite sans autorisation préalable.
                <h2 className='h2-legal'><span style={{color : "red"}}>A lire</span></h2>
                Ce site est un site d'école, il ne loue rien et n'a rien à vendre.<br /> 
                Les photos sont tirées de banques d'images gratuites<br />
                Exceptionnellement reprises sur des vrais sites constructeurs/marchands en prenant soin de diversifier les marques<br />
                Les textes et descriptions des véhicules sont réels provenant des sites cités ci-dessous ou générés par IA. <br />
                Sauf erreur nous retrouvons donc :<br />
                credit video :<br />
                https://pixabay.com/fr/users/ladislavbur-16302054/?Ladislav Búr<br />

                credit photo :<br />
                Photo de Stefan de Vries<br />
                https://www.pexels.com/fr-fr/photo/camion-daf-xf-moderne-a-andijk-pays-bas-29206469/<br />
                Photo de hitesh Sarain: https://www.pexels.com/fr-fr/photo/28264503/<br />
                venditacamion.com<br />
                annunciindustriali.it<br />
                demalift.it<br />
                123.rf<br />
                Fruehauf<br />
                benalu<br />
                Chereau<br />
                Kässbohrer<br />
                Trouillet<br />
                Lecitrailer<br />
                Socari<br />
                Solido<br />
                trucks-heavy.com<br />
                iveco<br />
                mobile.de<br />
                logo page histoire : Photo de Mike Bird: https://www.pexels.com/fr-fr/photo/voiture-vintage-noire-sur-garage-212100/<br />
                Photo de Maxim Tolchinskiy sur Unsplash<br />
                pexels-photo-28264503<br />
                pexels-sdvmovies-29206469<br />
                Photo de Mert Dinçer: https://www.pexels.com/fr-fr/photo/vehicule-transport-camion-urbain-18982322/ renault<br />
                Photo de Alex  Surd: https://www.pexels.com/fr-fr/photo/route-vehicule-transport-camion-10963705/ renault 2<br />
                Photo de Emrecan Dora: https://www.pexels.com/fr-fr/photo/rouge-voiture-vehicule-parking-18942492/ scania<br />
                https://pixabay.com/fr/users/gregor-27062/? mercedes<br />
                pexels-mikebirdy-212100 (voiture du garage)<br />
                pixabay.com/fr/users/kapa65-61253 scania blanc<br />
                pixabay.com/fr/users/ly452740370-5998799 citerne<br />
                pixabay.com/fr/users/rauschenberger-4614580/ citerne remorque<br />
               
            </div>
        </div>
    );
};
export default Legal;